import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
  distribution: {
    listItems: [],
    activeItem: {},
    loading: false,
  },
};
export const getFeesAndChargesListItems = createAsyncThunk(
  "feesAndCharges/getFeesAndChargesListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.feesCharges.getList(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getFeesAndChargesDetailById = createAsyncThunk(
  "feesAndCharges/getFeesAndChargesDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.feesAndCharges.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.commission_id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const getFeesChargesDistributionListItems = createAsyncThunk(
  "feesAndCharges/getFeesChargesDistributionListItems",
  async (commissionId: string, { rejectWithValue }) => {
    if (!commissionId) return rejectWithValue("Invalid commission ID");
    try {
      const response: any = await apiServices.distribution.get(commissionId);
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch distribution list");
      }
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getFeesChargesDistributionDetailById = createAsyncThunk(
  "feesAndCharges/getFeesChargesDistributionDetailById",
  async (distributionId: string, { getState, rejectWithValue }) => {
    if (!distributionId) return rejectWithValue("Invalid distribution ID");
    const state: any = getState();
    const itemDetail = state.feesAndCharges.distribution.listItems.find(
      (item: any) => item.commission_allocation_id === distributionId
    );
    return itemDetail || rejectWithValue("distribution not found in state");
  }
);

export const feesAndChargesSlice = createSlice({
  name: "feesAndCharges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeesAndChargesListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getFeesAndChargesListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getFeesAndChargesListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getFeesAndChargesDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getFeesAndChargesDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getFeesAndChargesDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      })
      .addCase(getFeesChargesDistributionListItems.pending, (state) => {
        state.distribution.loading = true;
        state.distribution.listItems = [];
      })
      .addCase(getFeesChargesDistributionListItems.fulfilled, (state, action) => {
        state.distribution.loading = false;
        state.distribution.listItems = action.payload;
      })
      .addCase(getFeesChargesDistributionListItems.rejected, (state, action) => {
        state.distribution.loading = false;
        console.error("Error fetching distribution list:", action.payload);
      })
      .addCase(getFeesChargesDistributionDetailById.fulfilled, (state, action) => {
        state.distribution.activeItem = action.payload;
      });
  },
});
export const {} = feesAndChargesSlice.actions;
export default feesAndChargesSlice.reducer;
